module.exports = __webpack_public_path__ + "static/media/Segment4.680af2ba.jpg";